import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {useCallback, useMemo} from "react";
import {getUserAccessByKeys} from "@containers/account/access/constants/getUserAccess";
import {GetUserAccessFn, PropsGetUserAccess} from "@containers/account/access/types";

export const useGetUserAccess = (): {
	getUserAccess: GetUserAccessFn
} => {
	const {authorities} = useAppContext()
	
	const getUserAccess = useCallback(({
										   keys,
										   accessType = 'strict'
									   }: {
		keys: string | string[],
		accessType?: 'strict' | 'or'
	}): boolean => {
		return getUserAccessByKeys({
			keys,
			accessType,
			authorities
		})
	}, [authorities])
	
	return {
		getUserAccess
	}
}


export const useGetUserAccessWidthState = ({
											   keys,
											   accessType = 'strict'
										   }: PropsGetUserAccess): {
	access: boolean
} => {
	const {authorities} = useAppContext()
	const access = useMemo(() => {
		return getUserAccessByKeys({
			keys,
			accessType,
			authorities
		})
	}, [authorities, keys])
	
	return {
		access
	}
}
